<script>
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { customerService } from "../../services";
import { error_message, success_message, debounce } from "../../Helper/helper";

export default {
  components: { pagination },
  data() {
    const { status,type,orderBy,sortBy} = this.$route.query;
    return {
      config: config,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != '' ? orderBy : true,
      customers: [],
      customerData: [],
      customerCount: '',
      paginations: {},
      limit: 2,
      search: "",
      status: status == undefined ? "0" :status,
      type : type || '',
      loading: true,
      isDownloading: false,
      searchData:debounce(()=>{
          const {status,type,orderBy,sortBy} = this.$data;
          this.$router.replace({name: 'customer-list', query: {status,type,orderBy,sortBy}})
          this.getCustomerList();
      },500),
      fields: [
        {
          key: "unique",
          label: this.trans.get("__JSON__.Customer ID"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "user_name",
          label: this.trans.get("__JSON__.Name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.trans.get("__JSON__.Email"),
          sortable: true,
        },
        {
          key: "mobile_number",
          label: this.trans.get("__JSON__.Phone Number"),
          sortable: true,
        },
        {
          key: "order_count",
          label: this.trans.get("__JSON__.Orders"),
          sortable: true,
        },
        {
          key: "user_role",
          label: this.trans.get("__JSON__.Customer Type"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "status",
          label: this.trans.get("__JSON__.Status"),
          sortable: false,
          thClass:"dis-event"
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
          thClass:"dis-event"
        },

      ],
    };
  },
  mounted() {
    this.getCustomerList();
  },
  methods: {
    onRowClicked(item) {
      this.$router.push({name: 'customer-detail',params: { user_id: this.base64(item.user_id)}})
    },
    downloadsCSV: function () {
      let customerData = "\ufeff" + "Customer Id,Name,Email,Phone Number,Order,Status\n";
      this.customerData.forEach((el) => {
        var line =
          el["unique"] +
          "," +
          el["user_name"] +" " + el["last_name"] +
          "," +
          el["email"] +
          "," +
          el["mobile_number"] +
          "," +
          el["order_count"] +
          "," +
          (el["status"] == 0 ? "Active" : "Inactive") +
          "\n";
        customerData += line;
      });
      var blob = new Blob([customerData], { type: "csv/plain" });
      var currentDate = new Date();
      var date = new Date().toLocaleString();
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Customers" + date + ".csv";
      link.click();
    },
    getCustomerList(page) {
      this.loading = true;
      var filters = {
        search: this.search,
        status: this.status,
        type: this.type,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
      }
      customerService
        .getCustomer(filters)
        .then((response) => {
          this.loading = false;
          this.paginations = response.data.result.data;
          this.customers = response.data.result.data.data;
          this.customerCount = response.data.result.customerCount;
        });
    },
    customerExportCsv() {
      this.isDownloading = true;
      customerService
        .customerExportCsv({ status: this.status,type: this.type ,sortBy: this.sortBy, orderBy: this.sortDesc ? "desc" : "asc" })
        .then((response) => {
          this.isDownloading = false;
          this.customerData = response.data.result;
          this.downloadsCSV();
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getCustomerList();
    },
    blockById(user_id){
      if (confirm("Are you sure you want to block?")) {
        customerService
          .changeCustomerStatus({ user_id: user_id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getCustomerList();
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
    unblockById(user_id){
      if (confirm("Are you sure you want to Unblock?")) {
        customerService
          .unblockCustomer({ user_id: user_id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getCustomerList();
            } else {
              error_message(response.data.message);
            }
          });
      }
    },
    deleteById(user_id){
      if (confirm("Are you sure you want to delete?")) {
        customerService
          .deleteCustomer({ user_id: user_id })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.getCustomerList();
            } else {
              error_message(response.data.message);
            }
          });
          
      }
    },
    customerNo(id){
      var str = "" + id;
      var pad = "0000";
      var ans = pad.substring(8, pad.length - str.length) + str;
      return ans;
  }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Customers') }}({{customerCount}})</h4>
          </div>
          <div class="page-title-right d-flex">
            <router-link :to="{name: 'customer-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.Add Customer') }}
            </router-link>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded export-btn"
              v-if="isDownloading"
              disabled
            >{{ trans.get('__JSON__.Exporting...') }}</button>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded export-btn"
              v-else
            >{{ trans.get('__JSON__.Export To CSV') }}</button>
            <button
              @click="customerExportCsv"
              class="btn btn-primary btn-rounded m-export-btn"
            ><i class="bx bx-archive-in"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Customer Type') }} :</label>
                    <select class="custom-select" v-model="type" @change="searchData()">
                      <option value="" selected>{{ trans.get('__JSON__.All') }}</option>
                      <option value="5">{{ trans.get('__JSON__.Business') }}</option>
                      <option value="1">{{ trans.get('__JSON__.Private') }}</option>
                     
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Status') }} :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="0" selected>{{ trans.get('__JSON__.Active') }}</option>
                      <option value="3">{{ trans.get('__JSON__.Block') }}</option>
                      <option value="1">{{ trans.get('__JSON__.Inactive') }}</option>
                      
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive cust_tbl">
                <b-table
                  :items="customers"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                  @row-clicked="onRowClicked"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                    </div>
                  </template>

                  <template v-slot:cell(unique)="data">
                      <h5 class="font-size-14">{{ customerNo(data.item.unique) }}</h5>
                  </template>

                  <template v-slot:cell(user_name)="data">
                    <h5 class="font-size-14">{{ data.item.user_name }} {{ data.item.last_name }} {{ (data.item.name == null) ? '' : ' (' + data.item.name + ')' }}</h5>
                  </template>

                  <template v-slot:cell(user_role)="data">
                    <div
                      v-if="data.item.user_role === '1'"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >{{ trans.get('__JSON__.Private') }}</div>
                    <div
                      v-if="data.item.user_role === '5'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Business') }}</div>
                  </template>

                  <template v-slot:cell(status)="data">
                    <div
                      v-if="data.item.status == '1'"
                      class="badge badge-pill badge-soft-danger font-size-12"
                    >{{ trans.get('__JSON__.Inactive') }}</div>
                    <div
                      v-if="data.item.status == '0'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Active') }}</div>
                    <div
                      v-if="data.item.status == '3'"
                      class="badge badge-pill badge-soft-success font-size-12"
                    >{{ trans.get('__JSON__.Block') }}</div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <router-link
                      :to="{name: 'customer-detail',params: { user_id:base64(data.item.user_id)}}"
                      class="btn btn-primary btn-sm btn-rounded"
                    >View</router-link>
                    <button
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="deleteById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Delete') }}</button>
                    <button v-if="data.item.status == 0 || data.item.status == 1"
                      type="submit"
                      class="btn btn-danger btn-sm btn-rounded ml-1"
                      @click="blockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Block') }}</button>
                    <button v-if="data.item.status == 3"
                      type="submit"
                      class="btn btn-success btn-sm btn-rounded ml-1"
                      @click="unblockById(base64(data.item.user_id))"
                    >{{ trans.get('__JSON__.Unblock') }}</button>
                  </template>

                  <template #empty>
                    <p class="text-center">{{ trans.get('__JSON__.No Customer') }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getCustomerList"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

